var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 35C33.75 35 34.1667 34.8333 34.5 34.5C34.8333 34.1667 35 33.75 35 33.25V26.5C35 26.1389 34.875 25.8125 34.625 25.5208C34.375 25.2292 34.0556 25.0278 33.6667 24.9167L27.9167 23.75C27.5278 23.6944 27.1319 23.7292 26.7292 23.8542C26.3264 23.9792 26 24.1667 25.75 24.4167L21.8333 28.3333C20.7778 27.7222 19.7778 27.0486 18.8333 26.3125C17.8889 25.5764 16.9861 24.7778 16.125 23.9167C15.2083 23.0278 14.3681 22.1042 13.6042 21.1458C12.8403 20.1875 12.1806 19.1944 11.625 18.1667L15.6667 14.0833C15.8889 13.8611 16.0417 13.5972 16.125 13.2917C16.2083 12.9861 16.2222 12.6111 16.1667 12.1667L15.0833 6.33333C15.0278 5.97222 14.8472 5.65972 14.5417 5.39583C14.2361 5.13194 13.8889 5 13.5 5H6.75C6.25 5 5.83333 5.16667 5.5 5.5C5.16667 5.83333 5 6.25 5 6.75C5 10.2222 5.75694 13.6528 7.27083 17.0417C8.78472 20.4306 10.9306 23.5139 13.7083 26.2917C16.4861 29.0694 19.5694 31.2153 22.9583 32.7292C26.3472 34.2431 29.7778 35 33.25 35Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d9a5276e6d65072eb2688dbbde0b24eb.svg";
export { ForwardRef as ReactComponent };